export const insightTextContent = {
  headingText: "Insight",
  paraText_1:
    "Our slot game development services bring together revolutionary concepts and vision and transform them into highly immersive slot games. We focus on innovative designs, endless entertainment, and immersive gameplay where each game is engineered with precision to keep your players hooked.",
  paraText_2:
    "Driven by innovation and our commitment to slot excellence, we continue to push the boundaries and continue to consistently deliver highly captivating slot games.",
  btnText: "Contact Us",
  imageSrc: "/assets/stock-img/laptop_iphone_img_01.webp",
};